import { IAdvertiser, IAdvertiserService } from "./model"
import { advertiserRPO } from "./repository"
import { createAdvertiser, getAdvertiserById, getAdvertiserByName } from "./tools/common"

export const advertiserSVC: IAdvertiserService = {
  getAllAdvertisers(): Promise<IAdvertiser[]> {
    return new Promise<IAdvertiser[]>((resolve, reject) => {
      advertiserRPO
        .getAllAdvertisers()
        .then(advertisers => resolve(advertisers))
        .catch(error => {
          console.error(error)
          reject("Unable to get all advertisers")
        })
    })
  },
  getById: getAdvertiserById,
  getByName: getAdvertiserByName,
  createAdvertiser
}
